import { INR } from '../constants';
const showInvoiceNumberAndDates = (
  reason_for_transfer_list,
  selected_reason_for_transfer,
  destinantion_currency
) => {
  if (selected_reason_for_transfer && destinantion_currency) {
    const codes = [
      'IR01801',
      'IR01802',
      'IR01806',
      'IR01803',
      'IR01804',
      'IR01805',
      'IR01807',
      'IR01808',
      'IR01810',
      'IR01809',
      'IR01811'
    ];
    const selectedCode = reason_for_transfer_list.filter(
      (ele) => ele.key === selected_reason_for_transfer
    );
    if (
      selectedCode.length > 0 &&
      codes.includes(selectedCode[0].code) &&
      destinantion_currency === INR
    )
      return true;
  }
  return false;
};
export default showInvoiceNumberAndDates;
